import { CellSelection } from '@tiptap/pm/tables'

// CellSelection.from / to は ranges[0]（= head セルのレンジ）にしか対応しないため、
// 範囲内の他セル（anchor セル含む）の判定には ranges 配列を走査する必要がある。
export const isPosInCellSelection = (
  selection: CellSelection,
  pos: number
): boolean => selection.ranges.some(r => pos >= r.$from.pos && pos <= r.$to.pos)
